import React, { useEffect, useState } from 'react';
import '../style/sidebar.css';
import { Link, useNavigate } from 'react-router-dom';
import { useAppId } from '../context/AppIdContext';

const Sidebar = () => {
    // --- THE FIX: Pulled in setUserType and other setters to sync context properly ---
    const {
        appId, setAppId,
        userName, setUserName,
        userPhoto, setUserPhoto,
        language, setLanguage,
        userType, setUserType,
        setUserId, setTotalVoters,
        logout
    } = useAppId();

    const [isMobileOpen, setIsMobileOpen] = useState(false);
    const [isSettingsOpen, setIsSettingsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const navigate = useNavigate();

    // --- Role Verification Logic ---
    const activeRole = userType || localStorage.getItem('userType') || localStorage.getItem('designation') || localStorage.getItem('role');
    const roleCode = activeRole ? activeRole.toUpperCase() : 'A';

    const isAdmin = roleCode === 'A' || roleCode === 'ADMIN';
    const isSubAdmin = roleCode === 'SA' || roleCode === 'SUB_ADMIN';
    const isBoothPramukh = roleCode === 'BP' || roleCode === 'BOOTH_PRAMUKH';
    const isShaktiKendra = roleCode === 'SK' || roleCode === 'SHAKTI_KENDRA';

    // --- 1. Manual Translation Dictionary ---
    const t = {
        en: {
            dashboard: "Dashboard",
            admin: "Admin",
            subAdmin: "Sub Admin",
            boothPramukh: "Booth Pramukh",
            sahBoothPramukh: "Sah Booth Pramukh",
            shaktiKendra: "Shakti Kendra Pramukh",
            volunteers: "Volunteers",
            callCenter: "Call Center",
            masterSearch: "Master Search",
            speakSearch: "Speak And Search",
            quickSearch: "Quick Search",
            boothWise: "Booth Wise Voters",
            pollingWise: "Polling Wise Voters",
            ageWise: "Age wise Voters",
            surnameWise: "Surname Wise",
            scanId: "SCAN ID",
            language: "Language",
            settings: "Settings",
            cadresLabel: "cadres",
            masterSearchLabel: "Master Search",
            reportsLabel: "Reports",
            slipSendingReport: "Slip Sending Report",
            surveyWiseReport: "Cadre Wise Survey Report",
            survey: "Survey", // Added for BP
            callCenterReport: "Call Center Survey Report",
            communicationLabel: "Communication & Groups", // Added
            myPhonebook: "My Phonebook",
            myGroup: "My Group",
            surnameGroup: "Surname Group",
            preferencesLabel: "Preferences",
            adminBadge: "Admin",
            wallet: "Wallet",
            logoutConfirmTitle: "Logout Confirmation",
            logoutConfirmMessage: "Are you sure you want to logout?",
            logoutCancel: "Cancel",
            logoutConfirm: "Yes, Logout"
        },
        hi: {
            dashboard: "डैशबोर्ड",
            admin: "एडमिन",
            subAdmin: "सब एडमिन",
            boothPramukh: "बूथ प्रमुख",
            sahBoothPramukh: "सह बूथ प्रमुख",
            shaktiKendra: "शक्ति केंद्र प्रमुख",
            volunteers: "कार्यकर्ता",
            callCenter: "कॉल सेंटर",
            masterSearch: "मास्टर खोज",
            speakSearch: "बोलकर खोजें",
            quickSearch: "त्वरित खोज",
            boothWise: "बूथ वार मतदाता",
            pollingWise: "पोलिंग वार मतदाता",
            ageWise: "आयु वार मतदाता",
            surnameWise: "सरनेम वार",
            scanId: "स्कैन आईडी",
            language: "भाषा",
            settings: "सेटिंग्स",
            cadresLabel: "कैडर",
            masterSearchLabel: "मास्टर सर्च",
            reportsLabel: "रिपोर्ट्स",
            slipSendingReport: "पर्ची भेजने की रिपोर्ट",
            surveyWiseReport: "कैडर वार सर्वेक्षण रिपोर्ट",
            survey: "सर्वेक्षण",
            callCenterReport: "कॉल सेंटर सर्वेक्षण रिपोर्ट",
            communicationLabel: "संचार और समूह",
            myPhonebook: "मेरी फोनबुक",
            myGroup: "मेरा समूह",
            surnameGroup: "उपनाम समूह",
            preferencesLabel: "प्राथमिकताएं",
            adminBadge: "प्रशासक",
            wallet: "वॉलेट",
            logoutConfirmTitle: "लॉगआउट की पुष्टि",
            logoutConfirmMessage: "क्या आप वाकई लॉगआउट करना चाहते हैं?",
            logoutCancel: "रद्द करें",
            logoutConfirm: "हाँ, लॉगआउट करें"
        },
        gu: {
            dashboard: "ડેશબોર્ડ",
            admin: "એડમિન",
            subAdmin: "સબ એડમિન",
            boothPramukh: "બૂથ પ્રમુખ",
            sahBoothPramukh: "સહ બૂથ પ્રમુખ",
            shaktiKendra: "શક્તિ કેન્દ્ર પ્રમુખ",
            volunteers: "કાર્યકર્તા",
            callCenter: "કૉલ સેન્ટર",
            masterSearch: "માસ્ટર શોધ",
            speakSearch: "બોલીને શોધો",
            quickSearch: "ઝડપી શોધ",
            boothWise: "બૂથ મુજબ મતદારો",
            pollingWise: "મતદાન મથક મુજબ મતદારો",
            ageWise: "ઉંમર મુજબ મતદારો",
            surnameWise: "અટક મુજબ",
            scanId: "સ્કેન આઈડી",
            language: "ભાષા",
            settings: "સેટિંગ્સ",
            cadresLabel: "કેડર",
            masterSearchLabel: "માસ્ટર સર્ચ",
            reportsLabel: "રિપોર્ટ્સ",
            slipSendingReport: "સ્લિપ મોકલવાનો રિપોર્ટ",
            surveyWiseReport: "કેડર મુજબ સર્વેક્ષણ રિપોર્ટ",
            survey: "સર્વે",
            callCenterReport: "કૉલ સેન્ટર સર્વેક્ષણ રિપોર્ટ",
            communicationLabel: "સંચાર અને જૂથો",
            myPhonebook: "મારી ફોનબુક",
            myGroup: "મારું જૂથ",
            surnameGroup: "ઉપનામ જૂથ",
            preferencesLabel: "પસંદગીઓ",
            adminBadge: "એડમિન",
            wallet: "વૉલેટ",
            logoutConfirmTitle: "લૉગઆઉટની પુષ્ટિ",
            logoutConfirmMessage: "શું તમે ખરેખર લૉગઆઉટ કરવા માંગો છો?",
            logoutCancel: "રદ કરો",
            logoutConfirm: "હા, લૉગઆઉટ કરો"
        }
    };

    const currentLang = language || 'en';
    const txt = t[currentLang];

    useEffect(() => {
        const checkAuthentication = () => {
            const storedAppId = localStorage.getItem('appId');
            const storedUserId = localStorage.getItem('userId');

            if (!storedAppId || !storedUserId) {
                navigate('/', { replace: true });
                return false;
            }

            // --- THE FIX: Instantly sync missing Context from LocalStorage upon login redirect ---
            if (!userType && setUserType) {
                const storedRole = localStorage.getItem('userType') || localStorage.getItem('designation') || localStorage.getItem('role');
                if (storedRole) setUserType(storedRole);
            }

            // Restore other context values if they're empty but localStorage has values
            if (!userName && storedUserId) {
                const storedUserName = localStorage.getItem('userName');
                const storedUserPhoto = localStorage.getItem('userPhoto');
                const storedTotalVoters = localStorage.getItem('totalVoters');

                if (storedUserName && setUserName) setUserName(storedUserName);
                if (storedUserPhoto && setUserPhoto) setUserPhoto(storedUserPhoto);
                if (storedAppId && setAppId) setAppId(storedAppId);
                if (storedUserId && setUserId) setUserId(storedUserId);
                if (storedTotalVoters && setTotalVoters) setTotalVoters(storedTotalVoters);
            }

            return true;
        };

        const timer = setTimeout(() => {
            const isAuthenticated = checkAuthentication();
            setIsLoading(!isAuthenticated);
        }, 100);

        return () => clearTimeout(timer);
    }, [navigate, userName, setUserName, setUserPhoto, setAppId, setUserId, setTotalVoters, userType, setUserType]);

    useEffect(() => {
        if (isMobileOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isMobileOpen]);

    const handleLogout = () => {
        const isConfirmed = window.confirm(txt.logoutConfirmMessage);
        if (isConfirmed) {
            logout();
            navigate('/', { replace: true });
        }
    };

    const handleNavClick = () => {
        setIsMobileOpen(false);
    };

    // --- THE FIX: Read instantly from localStorage if context is still catching up! ---
    const getDisplayRole = () => {
        if (!activeRole) return txt.adminBadge;

        if (roleCode === 'A' || roleCode === 'ADMIN') return txt.admin;
        if (roleCode === 'SA' || roleCode === 'SUB_ADMIN') return txt.subAdmin;
        if (roleCode === 'BP' || roleCode === 'BOOTH_PRAMUKH') return txt.boothPramukh;
        if (roleCode === 'K' || roleCode === 'KARYAKARTA') return txt.volunteers;
        if (roleCode === 'BS' || roleCode === 'SAH_BOOTH_PRAMUKH') return txt.sahBoothPramukh;
        if (roleCode === 'SK' || roleCode === 'SHAKTI_KENDRA') return txt.shaktiKendra;
        if (roleCode === 'CL' || roleCode === 'CALL_CENTER') return txt.callCenter;
        return activeRole;
    };

    if (isLoading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#0f172a', color: 'white' }}>
                <div>Loading...</div>
            </div>
        );
    }

    return (
        <>
            <button className="mobile-menu-btn custom-mobile-btn" onClick={() => setIsMobileOpen(true)} aria-label="Open Menu">
                <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                </svg>
            </button>

            {isMobileOpen && (
                <div className="sidebar-overlay" onClick={() => setIsMobileOpen(false)} />
            )}

            <div className={`sidebar-container ${isMobileOpen ? 'open' : ''}`}>
                <button className="mobile-close-btn" onClick={() => setIsMobileOpen(false)}>
                    <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                </button>

                <div className="sidebar-header">
                    <div className="logo-icon">
                        <div className="brand-icon">
                            <img src='https://maharashtra.bjpwings.com/img/admin/09022026022058_1770632573055.jpg' style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} alt="BJP Logo" />
                        </div>
                    </div>
                    <div className="logo-text-group">
                        <span className="logo-title">BJP Wings</span>
                        <span className="logo-subtitle"></span>
                    </div>
                </div>

                <div className="scrollable-content">
                    <div className="nav-section">
                        <Link to='/dashboard' className="nav-item" onClick={handleNavClick}>
                            <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                            </svg>
                            <span>{txt.dashboard}</span>
                        </Link>
                    </div>

                    {/* Cadres Section - Hidden for BP except Volunteers */}
                    {!isBoothPramukh && <div className="section-label">{txt.cadresLabel}</div>}
                    <div className="nav-section">
                        {isAdmin && (
                            <Link to='/admin' className="nav-item" onClick={handleNavClick}>
                                <svg className="nav-icon" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" /><path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                                <span>{txt.admin}</span>
                            </Link>
                        )}
                        {isAdmin && (
                            <Link to='/sub_admin' className="nav-item" onClick={handleNavClick}>
                                <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" /></svg>
                                <span>{txt.subAdmin}</span>
                            </Link>
                        )}
                        {isBoothPramukh && (
                            <Link to='#' className="nav-item" onClick={handleNavClick}>
                                <svg className="nav-icon" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" /><path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                                <span>Organization</span>
                            </Link>
                        )}
                        {isBoothPramukh && (
                            <Link to='#' className="nav-item" onClick={handleNavClick}>
                                <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" /></svg>
                                <span>Voter</span>
                            </Link>
                        )}
                        {(isAdmin || isSubAdmin) && (
                            <Link to='/booth_pramukh' className="nav-item" onClick={handleNavClick}>
                                <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                                <span>{txt.boothPramukh}</span>
                            </Link>
                        )}
                        {(isAdmin || isSubAdmin) && (
                            <Link to='/dis_saktikendra' className="nav-item" onClick={handleNavClick}>
                                <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /></svg>
                                <span>{txt.shaktiKendra}</span>
                            </Link>
                        )}
                        <Link to='/display_karyakarta' className="nav-item" onClick={handleNavClick}>
                            <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                            <span>{txt.volunteers}</span>
                        </Link>
                        {isAdmin && (
                            <Link to='/dis_call_center_user' className="nav-item" onClick={handleNavClick}>
                                <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M3 18v-6a9 9 0 0118 0v6" /><path d="M21 19a2 2 0 01-2 2h-1a2 2 0 01-2-2v-3a2 2 0 012-2h3zM3 19a2 2 0 002 2h1a2 2 0 002-2v-3a2 2 0 00-2-2H3z" /></svg>
                                <span>{txt.callCenter}</span>
                            </Link>
                        )}
                    </div>

                    <div className='section-label'>{txt.masterSearchLabel}</div>
                    <div className='nav-section'>
                        <Link to='/master_search' className="nav-item" onClick={handleNavClick}>
                            <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
                            <span>{txt.masterSearch}</span>
                        </Link>
                        <Link to='/speak_and_search' className="nav-item" onClick={handleNavClick}>
                            <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" /></svg>
                            <span>{txt.speakSearch}</span>
                        </Link>
                        <Link to='/quick_search' className="nav-item" onClick={handleNavClick}>
                            <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>
                            <span>{txt.quickSearch}</span>
                        </Link>
                        <Link to='/display_total_booth' className="nav-item" onClick={handleNavClick}>
                            <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" /></svg>
                            <span>{txt.boothWise}</span>
                        </Link>
                        <Link to='/display_polling_location_wise_voters' className="nav-item" onClick={handleNavClick}>
                            <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                            <span>{txt.pollingWise}</span>
                        </Link>
                        <Link to='/age_wise_search' className="nav-item" onClick={handleNavClick}>
                            <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                            <span>{txt.ageWise}</span>
                        </Link>
                        <Link to='/dis_all_surname' className="nav-item" onClick={handleNavClick}>
                            <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" /></svg>
                            <span>{txt.surnameWise}</span>
                        </Link>
                        <Link to='/scan_id' className="nav-item" onClick={handleNavClick}>
                            <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M3 8V6a2 2 0 012-2h2M3 16v2a2 2 0 002 2h2m14-12h-2a2 2 0 00-2-2h-2m6 10v2a2 2 0 01-2 2h-2" /></svg>
                            <span>{txt.scanId}</span>
                        </Link>
                    </div>

                    <div className='section-label'>{txt.reportsLabel}</div>
                    <div className='nav-section'>
                        <Link to='/get_total_slip_distribution_count' className="nav-item" onClick={handleNavClick}>
                            <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" /></svg>
                            <span>{txt.slipSendingReport}</span>
                        </Link>
                        <Link to='/dis_survey_dash_for_admin' className="nav-item" onClick={handleNavClick}>
                            <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
                            <span>{isBoothPramukh ? txt.survey : txt.surveyWiseReport}</span>
                        </Link>
                        {isAdmin && (
                            <Link to='/dis_admin_call_center_survey_dashboard' className="nav-item" onClick={handleNavClick}>
                                <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" /></svg>
                                <span>{txt.callCenterReport}</span>
                            </Link>
                        )}
                    </div>

                    {/* Communication Section - For Admin, SubAdmin, and BP */}
                    {(isAdmin || isSubAdmin || isBoothPramukh) && (
                        <>
                            <div className='section-label'>{txt.communicationLabel}</div>
                            <div className='nav-section'>
                                <Link to='/dis_contact_group_member' className="nav-item" onClick={handleNavClick}>
                                    <span className="nav-icon">📖</span>
                                    <span>{txt.myPhonebook}</span>
                                </Link>
                                <Link to='/dis_surname_group' className="nav-item" onClick={handleNavClick}>
                                    <span className="nav-icon">👪</span>
                                    <span>{txt.surnameGroup}</span>
                                </Link>
                                <Link to='/dis_my_group_member' className="nav-item" onClick={handleNavClick}>
                                    <span className="nav-icon">👥</span>
                                    <span>{txt.myGroup}</span>
                                </Link>
                            </div>
                        </>
                    )}

                    {/* <Link to='/dis_wtsp_msg_admin_dash' className="nav-item" onClick={handleNavClick}>
                        <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.5">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a2.25 2.25 0 0 0-2.25-2.25H15a3 3 0 1 1-6 0H5.25A2.25 2.25 0 0 0 3 12m18 0v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6m18 0V9M3 12V9m18 0a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 9m18 0V6a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 6v3" />
                        </svg>
                        <span>{txt.wallet}</span>
                    </Link> */}

                    <div className='section-label'>{txt.preferencesLabel}</div>
                    <div className='nav-section'>
                        <div className="nav-item" style={{ cursor: 'pointer', justifyContent: 'space-between' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                                <span>{txt.language}</span>
                            </div>

                            <select
                                className="language-dropdown"
                                value={language || 'en'}
                                onChange={(e) => setLanguage(e.target.value)}
                            >
                                <option value="en">English</option>
                                {/* <option value="hi">हिंदी</option>
                                <option value="gu">ગુજરાતી</option> */}
                            </select>
                        </div>

                        {/* <div className="nav-item" style={{ cursor: 'pointer' }} onClick={() => setIsSettingsOpen(!isSettingsOpen)}>
                            <svg className="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /><path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                            <span>{txt.settings}</span>
                        </div> */}
                    </div>
                    <div className="spacer"></div>
                </div>

                <div className="user-footer">
                    <div className="user-avatar-container">
                        <div className="avatar">
                            <img src={userPhoto ? userPhoto : `https://ui-avatars.com/api/?name=${encodeURIComponent(userName || 'User')}&background=random&color=fff`} alt="User" />
                        </div>
                        <span className="online-dot"></span>
                    </div>
                    <div className="user-info">
                        <span className="user-name" style={{ color: "white", fontSize: "14px", fontWeight: "600" }}>{userName}</span>
                        {/* --- DYNAMIC DESIGNATION MAPPED PROPERLY --- */}
                        <span className="user-badge">{getDisplayRole()}</span>
                    </div>
                    <button className="logout-btn" onClick={handleLogout} title={txt.logoutConfirmTitle}>
                        <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" /></svg>
                    </button>
                </div>
            </div>

            <style jsx>{`
                /* Modern Select Dropdown Styling */
                .language-dropdown {
                    background-color: rgba(255, 255, 255, 0.05);
                    color: #f8fafc;
                    border: 1px solid rgba(255, 255, 255, 0.1);
                    border-radius: 8px;
                    padding: 6px 28px 6px 12px;
                    font-size: 13px;
                    font-weight: 600;
                    outline: none;
                    cursor: pointer;
                    appearance: none;
                    -webkit-appearance: none;
                    -moz-appearance: none;
                    background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%2394a3b8%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3Cpolyline%20points%3D%226%209%2012%2015%2018%209%22%3E%3C%2Fpolyline%3E%3C%2Fsvg%3E");
                    background-repeat: no-repeat;
                    background-position: right 8px center;
                    background-size: 14px;
                    transition: all 0.2s ease;
                }
                .language-dropdown:hover {
                    background-color: rgba(255, 255, 255, 0.1);
                    border-color: rgba(255, 255, 255, 0.2);
                }
                .language-dropdown:focus {                  
                    border-color: #3b82f6;
                    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.25);
                }
                .language-dropdown option {
                    background-color: #0f172a;
                    color: #f8fafc;
                    font-weight: 500;
                    padding: 8px;
                }
                
                @media (max-width: 768px) {
                    .sidebar-container { display: flex; flex-direction: column; height: 100dvh; }
                    .scrollable-content { flex: 1; overflow-y: auto; }
                    .user-footer { display: flex !important; flex-shrink: 0; margin-top: auto; z-index: 10; }
                    
                    /* Original top-right position restored */
                    .custom-mobile-btn { 
                        position: fixed; 
                        right: 20px; 
                        left: auto; 
                        z-index: 999; 
                    }
                }
            `}</style>
        </>
    );
};

export default Sidebar;